import { Button, Popconfirm, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import 'moment/locale/ko';
import moment from 'moment';
import styled from 'styled-components';

import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface ProjectSharedFileListComponentProps {
  file: any;
  donwloadFile: (fileData: any) => void;
  onDelete?: (fileId: number) => void;
  openImagePreview: (imageData: any) => void;
}
function ProjectSharedFileListComponent({
  file,
  donwloadFile,
  onDelete,
  openImagePreview,
}: ProjectSharedFileListComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '파일명',
      dataIndex: 'name',
      width: '50%',
    },
    {
      title: '업로드 일시',
      dataIndex: 'createdAt',
      width: '30%',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    // {
    //   title: '제출일시',
    //   dataIndex: 'createdAt',
    // },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '20%',
      render: (text, record, index) => (
        <Space size="small">
          <Button
            size="small"
            className="edit-table-list-item"
            onClick={(e) => {
              e.stopPropagation();
              // if (isMobile) {
              //   alert(
              //     // '스마트폰에서는 다운로드를 지원하지 않습니다. PC에서 이용해주세요.',
              //     '스마트폰에서는 미리보기만 지원합니다. PC에서 다운로드 해 주세요.',
              //   );
              // } else {
              //   donwloadFile(record);
              // }
              donwloadFile(record);
            }}
          >
            다운로드
          </Button>
          {/* <Button
            size="small"
            disabled={
              record.name.split('.').pop() !== 'jpg' &&
              record.name.split('.').pop() !== 'jpeg' &&
              record.name.split('.').pop() !== 'png' &&
              record.name.split('.').pop() !== 'pdf'
            }
            onClick={() => {
              openImagePreview(record);
            }}
          >
            미리보기
          </Button> */}
          {!!onDelete && (
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              onConfirm={() => {
                onDelete(record.id);
              }}
            >
              <Button size="small" className="delete-table-list-item">
                삭제
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Table<any>
        rowKey="id"
        columns={columns}
        dataSource={file}
        pagination={{
          defaultPageSize: 20,
          // showSizeChanger: true,
          // pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
          position: ['bottomCenter'],
        }}
      />
    </StyledDiv>
  );
}
export default ProjectSharedFileListComponent;
